const AssetTableEnum = {
  ASSET_IMAGE: "",
  ASSET_NAME: "Asset Name",
  ASSET_ID: "Asset ID",
  MAKE: "Make",
  MODEL: "Model",
  DESCRIPTION: "Description",
  DISPOSITION: "Disposition",
  ACTIONS: "Actions"
};

export default AssetTableEnum;
